(function () {
  'use strict';
  /* Bloc 1 / 2 / 3 unites. Volontairement INDEPENDANT de toudoupet-product.js :
     le fieldset ne porte pas data-tp-x2, donc le moteur x2 l'ignore et les
     produits Rouleau / Pliable / Tapis ne sont pas affectes.
     Integration : on ecrit l'ID a ajouter dans #tpVariantIdInput (variante
     source en « 1 unite », variante bundle en Pack de 2 / 3) ; l'ajout au
     panier existant envoie donc le bon identifiant sans etre modifie.
     On reapplique ce choix apres chaque evenement tp:variantchange emis par le
     selecteur de couleur principal.
     CLE CANONIQUE : IDs source tries NUMERIQUEMENT, joints par « | ».
     L'ordre visuel choisi par le client n'en depend pas. */
  var root = document.querySelector('[data-tp-trio]');
  if (!root) return;
  var section = document.querySelector('.tp-product-hero');
  var variantInput = document.getElementById('tpVariantIdInput');
  var qtyWrap = section ? section.querySelector('.tp-quantity-selector') : null;
  var qtyInput = document.getElementById('tpQtyValue');
  var data = null;
  try { data = JSON.parse(root.querySelector('[data-tp-trio-data]').textContent); } catch (e) { return; }
  if (!data || !data.couleurs || !data.couleurs.length) return;

  var srcId = String(root.dataset.variant || (variantInput ? variantInput.value : ''));
  var c2 = null, c3 = null, c2Manual = false, c3Manual = false;
  var errorEl = root.querySelector('[data-tp-trio-error]');

  function colorByVariant(id) { return data.couleurs.find(function (c) { return String(c.v) === String(id); }) || data.couleurs[0]; }
  function colorByLabel(l) { return data.couleurs.find(function (c) { return c.l === l; }) || null; }
  function offer() { var r = root.querySelector('[data-tp-trio-offer]:checked'); return r ? r.value : '1'; }
  function key(ids) { return ids.map(Number).sort(function (a, b) { return a - b; }).join('|'); }
  function resolve(kind) {
    var c1 = colorByVariant(srcId);
    if (kind === '2') {
      var o2 = colorByLabel(c2) || c1;
      var id2 = data.x2.paires[key([c1.v, o2.v])];
      return id2 ? { id: id2, ok: data.x2.dispo.indexOf(id2) !== -1 } : null;
    }
    if (kind === '3') {
      var p2 = colorByLabel(c2) || c1, p3 = colorByLabel(c3) || c1;
      var id3 = data.x3.triplets[key([c1.v, p2.v, p3.v])];
      return id3 ? { id: id3, ok: data.x3.dispo.indexOf(id3) !== -1 } : null;
    }
    return null;
  }
  function ensureDefaults() {
    var c1 = colorByVariant(srcId);
    if (!c2Manual || !colorByLabel(c2)) { c2 = c1.l; c2Manual = c2Manual && !!colorByLabel(c2); }
    if (!c3Manual || !colorByLabel(c3)) { c3 = c1.l; c3Manual = c3Manual && !!colorByLabel(c3); }
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function swatchHtml(slot, active) {
    var c1 = colorByVariant(srcId);
    return data.couleurs.map(function (c) {
      var ok = true;
      if (slot === '2') { var r2 = data.x2.paires[key([c1.v, c.v])]; ok = !!r2 && data.x2.dispo.indexOf(r2) !== -1; }
      else { var other = slot === '3a' ? (colorByLabel(c3) || c1) : (colorByLabel(c2) || c1); var r3 = data.x3.triplets[key([c1.v, slot === '3a' ? c.v : (colorByLabel(c2) || c1).v, slot === '3a' ? other.v : c.v])]; ok = !!r3 && data.x3.dispo.indexOf(r3) !== -1; }
      var on = c.l === active;
      return '<button type="button" class="tp-x2__swatch' + (on ? ' is-active' : '') + (ok ? '' : ' is-unavailable') + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (ok ? '' : ' aria-disabled="true"') + ' data-tp-trio-color="' + esc(c.l) + '" data-slot="' + slot + '" style="--tp-swatch:' + esc(c.hex || '#A8A39B') + '"><span class="tp-x2__swatch-dot" aria-hidden="true"></span>' + esc(c.l) + (ok ? '' : ' <span class="tp-visually-hidden">indisponible</span>') + '</button>';
    }).join('');
  }
  function setImg(sel, url) { var el = root.querySelector('[data-tp-trio-img="' + sel + '"]'); if (el && url && el.getAttribute('src') !== url) el.setAttribute('src', url); }

  var lastCur = '1';
  function refresh(userPick) {
    ensureDefaults();
    var c1 = colorByVariant(srcId);
    var p2 = colorByLabel(c2) || c1, p3 = colorByLabel(c3) || c1;
    var cur = offer();

    /* Miniatures : chaque offre montre exactement le nombre de produits vendus */
    setImg('1a', c1.i);
    setImg('2a', c1.i); setImg('2b', p2.i);
    setImg('3a', c1.i); setImg('3b', p2.i); setImg('3c', p3.i);

    /* Disponibilite reelle du bundle, jamais forcee */
    var r2 = resolve('2'), r3 = resolve('3');
    var i2 = root.querySelector('[data-tp-trio-offer][value="2"]');
    var i3 = root.querySelector('[data-tp-trio-offer][value="3"]');
    if (i2) { i2.disabled = !(r2 && r2.ok); if (i2.disabled && i2.checked) { i2.checked = false; root.querySelector('[data-tp-trio-offer][value="1"]').checked = true; cur = '1'; } }
    if (i3) { i3.disabled = !(r3 && r3.ok); if (i3.disabled && i3.checked) { i3.checked = false; root.querySelector('[data-tp-trio-offer][value="1"]').checked = true; cur = '1'; } }

    /* Selecteurs conditionnels : rien en 1 unite, un en x2, deux en x3 */
    var pick2 = root.querySelector('[data-tp-trio-picker="2"]');
    var pick3 = root.querySelector('[data-tp-trio-picker="3"]');
    if (pick2) { pick2.hidden = cur === '1'; var s2 = pick2.querySelector('[data-tp-trio-swatches]'); if (s2) s2.innerHTML = swatchHtml(cur === '3' ? '3a' : '2', c2); }
    if (pick3) { pick3.hidden = cur !== '3'; var s3 = pick3.querySelector('[data-tp-trio-swatches]'); if (s3) s3.innerHTML = swatchHtml('3b', c3); }
    var sum = root.querySelector('[data-tp-trio-summary]');
    if (sum) {
      if (cur === '2') sum.innerHTML = 'Votre duo : <strong>' + esc(c1.l) + ' + ' + esc(p2.l) + '</strong>';
      else if (cur === '3') sum.innerHTML = 'Votre trio : <strong>' + esc(c1.l) + ' + ' + esc(p2.l) + ' + ' + esc(p3.l) + '</strong>';
      else sum.innerHTML = '';
      sum.hidden = cur === '1';
    }
    if (errorEl) errorEl.hidden = !((cur === '2' && !(r2 && r2.ok)) || (cur === '3' && !(r3 && r3.ok)));

    /* Identifiant reellement ajoute au panier */
    if (variantInput) {
      if (cur === '2' && r2 && r2.ok) variantInput.value = r2.id;
      else if (cur === '3' && r3 && r3.ok) variantInput.value = r3.id;
      else variantInput.value = srcId;
    }
    /* P3.1 : le selecteur de quantite reste visible et affiche les UNITES
       (2 ou 3 sur un lot ; la ligne panier reste UN bundle, cf.
       toudoupet-product.js). Retour a 1 seulement quand le client repasse
       lui-meme sur « 1 unite » depuis un lot (userPick), jamais sur un repli
       automatique (lot indisponible) : la quantite choisie est conservee. */
    if (qtyInput) {
      var q = parseInt(qtyInput.value, 10) || 1;
      if (cur !== '1') qtyInput.value = cur;
      else if (userPick && lastCur !== '1' && q === parseInt(lastCur, 10)) qtyInput.value = 1;
    }
    lastCur = cur;

    /* Offre reellement ajoutee, publiee pour toudoupet-product.js (total sous
       le CTA, barre mobile : meme affichage que l'offre x2) et pour l'encart
       VIP (masque sur un pack). Vide en « 1 unite ». */
    var units = (cur === '2' && r2 && r2.ok) ? 2 : (cur === '3' && r3 && r3.ok) ? 3 : 0;
    root.dataset.offerUnits = units ? String(units) : '';
    root.dataset.offerCents = units ? String(units === 2 ? data.x2.prix : data.x3.prix) : '';
    root.dispatchEvent(new CustomEvent('tp:offerchange', { bubbles: true, detail: { source: 'trio', units: units } }));
  }

  root.addEventListener('change', function (e) {
    if (e.target.closest('[data-tp-trio-offer]')) refresh(!root.dataset.tpSyncing);
  });
  root.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-tp-trio-color]');
    if (!sw || sw.classList.contains('is-unavailable')) return;
    var slot = sw.dataset.slot;
    if (slot === '3b') { c3 = sw.dataset.tpTrioColor; c3Manual = true; }
    else { c2 = sw.dataset.tpTrioColor; c2Manual = true; }
    refresh();
  });
  root.addEventListener('keydown', function (e) {
    var sw = e.target.closest('[data-tp-trio-color]');
    if (!sw || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault(); sw.click();
  });
  /* Changement de couleur principale : on relit la variante source puis on
     rapplique l'identifiant bundle (le moteur produit vient d'ecrire la source). */
  if (section) section.addEventListener('tp:variantchange', function (e) {
    if (e.detail && e.detail.variantId) srcId = String(e.detail.variantId);
    refresh();
  });

  refresh();
})();